/* Giftera – „Ce găsește … când deschide cutia” (sections/giftera-unboxing.liquid).
   Starea inițială e randată pe server; aici doar se ține pasul cu alegerile de pe pagină:
   · lănțișorul: la `change` pe input[data-gf-value] (emis de gf-model-picker) se schimbă numele și poza;
   · cardul: la `change` pe input[data-gf-custom] se trece între cardul produsului și „Designul tău”;
     cât e ales „Designul tău”, pasul arată cardul-fantomă sau copia canvasului din <gf-card-designer>,
     făcută cu drawImage la fiecare eveniment `gf:card-preview` emis de designer (fără cronometre).
   Fără dependențe; nu scrie nimic în formular și nu atinge proprietățile de linie. */
(function () {
  'use strict';

  var doc = document;
  var READY = 'gfUnbReady';

  /** @param {HTMLElement} root */
  function init(root) {
    if (root.dataset[READY]) return;
    root.dataset[READY] = '1';

    /* ---------- lănțișorul ---------- */
    var chain = root.querySelector('[data-gf-unb-chain]');
    var img = chain && chain.querySelector('[data-gf-unb-model-img]');
    var title = chain && chain.querySelector('[data-gf-unb-model-title]');
    var change = chain && chain.querySelector('[data-gf-unb-change]');
    var models = {};
    var mapEl = chain && chain.querySelector('[data-gf-unb-models]');
    if (mapEl) {
      try { models = JSON.parse(mapEl.textContent || '{}') || {}; } catch (e) { models = {}; }
    }

    /* numele fișierului, fără gazdă și fără ?v=…: aceeași poză poate veni cu adrese scrise diferit */
    function fileOf(url) {
      return String(url || '').split('?')[0].split('/').pop();
    }

    function syncModel() {
      if (!chain) return;
      var valueInput = doc.querySelector('input[data-gf-value]');
      var codeInput = doc.querySelector('input[data-gf-code]');
      var name = valueInput ? valueInput.value.trim() : '';
      var code = codeInput ? codeInput.value.trim() : '';
      if (!name) return;
      if (title && title.dataset.template) {
        var text = title.dataset.template.split('__NAME__').join(name);
        if (title.textContent !== text) title.textContent = text;
      }
      var src = models[code];
      if (img && src && fileOf(img.getAttribute('src')) !== fileOf(src)) {
        img.classList.add('is-swapping');
        var done = function () { img.classList.remove('is-swapping'); };
        img.addEventListener('load', done, { once: true });
        img.addEventListener('error', done, { once: true });
        img.loading = 'eager';
        img.src = src;
      }
      if (img && img.dataset.altTemplate) img.alt = img.dataset.altTemplate.split('__NAME__').join(name);
    }

    if (change) {
      var toggle = doc.querySelector('gf-model-picker .gf-mp__toggle');
      if (toggle) {
        change.hidden = false;
        change.addEventListener('click', function () { toggle.click(); });
      }
    }

    /* ---------- cardul: trei stări ---------- */
    /* a) „Mesajul nostru” · b) „Designul tău”, nimic completat · c) „Designul tău”, cu text sau poză.
       Canvasul nu se desenează aici: <gf-card-designer> anunță fiecare redesenare (`gf:card-preview`),
       iar pasul copiază canvasul lui. Tot el spune dacă are conținut (detail.hasContent / .hasContent). */
    var card = root.querySelector('[data-gf-unb-card]');
    var stdParts = card ? Array.prototype.slice.call(card.querySelectorAll('[data-gf-unb-std]')) : [];
    var ownParts = card ? Array.prototype.slice.call(card.querySelectorAll('[data-gf-unb-own]')) : [];
    var copy = card && card.querySelector('[data-gf-unb-canvas]');
    var ghost = card && card.querySelector('[data-gf-unb-empty]');
    var edit = card && card.querySelector('[data-gf-unb-edit]');
    var live = card && card.querySelector('[data-gf-unb-live]');
    var state = 'std';

    function designer() { return doc.querySelector('gf-card-designer'); }

    function isCustom() {
      var checked = doc.querySelector('input[data-gf-custom]:checked');
      return !!checked && checked.dataset.gfCustom === 'true';
    }

    /** @param {HTMLCanvasElement | null | undefined} source */
    function paint(source) {
      if (!copy || !source) return false;
      try {
        var ctx = copy.getContext('2d');
        ctx.clearRect(0, 0, copy.width, copy.height);
        ctx.drawImage(source, 0, 0, copy.width, copy.height);
        return true;
      } catch (e) {
        return false;
      }
    }

    /**
     * @param {HTMLCanvasElement | null | undefined} source canvasul designerului
     * @param {boolean} filled designerul are text sau poză
     * @param {boolean} quiet fără anunț pentru cititoarele de ecran (starea de la încărcare)
     */
    function setCard(source, filled, quiet) {
      if (!card) return;
      var d = designer();
      var custom = isCustom() && !!d;
      var next = 'std';
      if (custom) next = filled && paint(source) ? 'filled' : 'empty';

      stdParts.forEach(function (el) { el.hidden = custom; });
      ownParts.forEach(function (el) { el.hidden = !custom; });
      if (copy) copy.hidden = next !== 'filled';
      if (ghost) ghost.hidden = next === 'filled';
      if (edit) {
        var label = (next === 'filled' ? edit.dataset.labelFilled : edit.dataset.labelEmpty) || '';
        if (label && edit.textContent !== label) edit.textContent = label;
      }
      if (next === state) return;
      state = next;
      if (live && !quiet) live.textContent = live.dataset[next] || '';
    }

    /* starea curentă, citită din designer (la încărcare și la schimbarea alegerii) */
    function syncCard(quiet) {
      var d = /** @type {any} */ (designer());
      setCard(d && d.canvas, !!d && d.hasContent === true, quiet === true);
    }

    /* Linkul din pas: urcă la panoul „Designul tău pentru card” și pune focusul pe primul câmp de text. */
    if (edit) {
      edit.addEventListener('click', function (event) {
        var d = designer();
        if (!d || d.hidden) return;
        event.preventDefault();
        var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        var field = /** @type {HTMLElement | null} */ (d.querySelector('[data-gf="title"], [data-gf="message"]'));
        (field || d).focus({ preventScroll: true });
        d.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
      });
    }

    /* Linkul de la „Mesajul nostru”: apasă butonul „Personalizează cardul” din selector. */
    var custom = card && card.querySelector('[data-gf-unb-custom]');
    if (custom) {
      var go = /** @type {HTMLElement | null} */ (doc.querySelector('[data-gf-card-go]'));
      if (go && designer()) {
        custom.hidden = false;
        custom.addEventListener('click', function () { go.click(); });
      }
    }

    /* seturile cu variante reale: poza cutiei e a variantei alese, aceeași ca în galerie (<script data-gf-variants>) */
    var variants = null;
    try {
      var variantsEl = doc.querySelector('script[data-gf-variants]');
      variants = variantsEl ? JSON.parse(variantsEl.textContent || '{}') : null;
    } catch (e) { variants = null; }
    function syncBox() {
      var boxImg = root.querySelector('[data-gf-unb-box] img');
      var codeInput = doc.querySelector('input[data-gf-code]');
      var v = variants && codeInput ? variants[codeInput.value.trim()] : null;
      if (!boxImg || !v || !v.src || fileOf(boxImg.getAttribute('src')) === fileOf(v.src)) return;
      var sized = function (n) { return v.src.replace(/([?&]width=)\d+/, '$1' + n); };
      boxImg.srcset = [300, 360, 540, 720, 900, 1080].map(function (n) { return sized(n) + ' ' + n + 'w'; }).join(', ');
      boxImg.src = sized(1080);
      if (v.alt) boxImg.alt = v.alt;
    }

    /* ---------- ascultare ---------- */
    doc.addEventListener('change', function (event) {
      var t = /** @type {HTMLElement} */ (event.target);
      if (!t || typeof t.matches !== 'function') return;
      if (t.matches('input[data-gf-value], input[data-gf-code]')) { syncModel(); syncBox(); }
      else if (t.matches('input[data-gf-custom]')) syncCard();
    });

    /* fiecare redesenare a previzualizării din selector: literă scrisă, poză decodată, fonturi sosite */
    doc.addEventListener('gf:card-preview', function (event) {
      var detail = /** @type {CustomEvent} */ (event).detail || {};
      setCard(detail.canvas, detail.hasContent === true, false);
    });

    syncModel();
    syncCard(true);
    /* starea radio-urilor poate fi restaurată de browser după încărcare */
    window.addEventListener('pageshow', function () { syncModel(); syncCard(true); });
  }

  function boot(scope) {
    (scope || doc).querySelectorAll('[data-gf-unboxing]').forEach(function (el) { init(/** @type {HTMLElement} */ (el)); });
  }

  if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', function () { boot(doc); });
  else boot(doc);

  doc.addEventListener('shopify:section:load', function (event) {
    boot(/** @type {HTMLElement} */ (event.target));
  });
})();
